	
<template>

<div>  
<appHeader > </appHeader>	
<div style=" padding:20px;margin-top:50px;background: #fff;  ">
<el-row><el-col :span="8" :offset="12"><h3>在线留言</h3></el-col></el-row>

 <el-form ref="form" :model="form" v-loading="loading" label-width="80px" style="margin: 50px">
  <el-form-item label="内容" required>
    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 6}" v-model="form.content"></el-input>
  </el-form-item>
  <el-form-item label="姓名" required>
    <el-input v-model="form.name"></el-input>
  </el-form-item>
  <el-form-item label="手机" required>
    <el-input v-model="form.tel"></el-input>
  </el-form-item>
  <el-form-item label="邮箱">
     <el-input v-model="form.email"></el-input>
  </el-form-item>
 
 
  <el-form-item>
    <el-button type="primary" :loading="is_loading" @click="onSubmit" >提交</el-button>
 
	
  </el-form-item>
</el-form>
</div>
<appFooter  > </appFooter> 

</div>
</template>

<script>
import appHeader from '@/components/appHeader'
import appFooter from '@/components/appFooter'  
 
export default  {
  components:{
    appHeader,
	appFooter
    },
    data() {
      return {
	    is_loading: false,
		loading: false,
        form: {
          name: '',
		  tel: '',
		  email: '',
		  company: '',
          content: '',
          
        }
      }
    },

    methods: {
	   
	  
      onSubmit() { 
	    let that = this;
	    let userInfo = localStorage.getItem('userInfo');
		let info = JSON.parse(userInfo);
		let id = info.id; 
		if (that.form.name == ''){
		    that.$message({
                    message: '请填写姓名!',
                    type: 'error'
                    });
			return;
			}
			
		if (that.form.content == ''){
		    that.$message({
                    message: '请填写内容!',
                    type: 'error'
                    });
			return;
			}			
			
		if (that.form.tel == ''){
		    that.$message({
                    message: '请填写电话!',
                    type: 'error'
                    });
			return;
			}			
		that.is_loading = true;
        console.log(that.form.birthday);  
		  $.ajax({
              type: "POST",
			  data: { 
			      name: that.form.name, 
				  tel: that.form.tel, 
				  email: that.form.email,
				  content: that.form.content,
				  } ,
              url: "https://www.myferp.com/admin/auth/sendMessage",
              dataType: "json",  //返回类型为 json  
              error: function(XMLHttpRequest, textStatus, errorThrown) { 
 		          that.is_loading = false;
			      that.$message({
                    message: data,
                    type: 'error'
                    });
                        return false;
                    },             
              success: function (data) {
		        that.is_loading = false;
				console.log(JSON.stringify(data));
				that.$message({
                  message: '提交成功!',
                  type: 'success'
                  });
                }
              });	
			 
			     
      }
    },
    mounted() {
	  this.getInfo();
	},
  }
</script>
 
 


// WEBPACK FOOTER //
// src/components/message.vue